<template>
  <a-spin :spinning="loading">
    <a-form :form="form">
      <a-form-item label="分类名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          name="name"
          v-decorator="['name', { rules: [{ required: true, message: '请输入证书分类的名称' }] }]"
        />
      </a-form-item>
      <a-form-item label="说明链接" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input name="link" v-decorator="['link', { rules: [{ type: 'url',required: true, message: '请输入正确的链接' }] }]" />
      </a-form-item>
      <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          name="sort"
          v-decorator="[
            'sort',
            {
              initialValue: '0'
            }
          ]"
        />
      </a-form-item>
      <a-form-item label="额外参数" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input name="extra" v-decorator="['extra', { rules: [{ message: '请输入额外参数' }] }]" />
      </a-form-item>
      <a-form-item label="分配考试码" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-switch
          checked-children="是"
          un-checked-children="否"
          name="need_code"
          v-decorator="[
            'need_code',
            {
              valuePropName: 'checked',
              initialValue: true
            }
          ]"
        />
      </a-form-item>
    </a-form>
  </a-spin>
</template>

<script>
import { requestData } from '@/api/api'
import { form } from '@/mixins/' // 引入

// 表单字段
const fields = ['name', 'link', 'sort', 'extra', 'need_code']
const apiList = {
    create: '/certificates/modes/create',
    update: '/certificates/modes/',
    getInfo: '/certificates/modes/'
}

export default {
    props: {
        // eslint-disable-next-line
        id: {
            type: Number,
            default: null
        }
    },
    mixins: [form],
    data () {
        return {
            fields,
            apiList
        }
    },
    mounted () {
        if (this.$props.id) {
            this.getFormData(this.$props.id, function (values) {
                // need_code分配考试码 1:需要 2：不需要
                values.need_code = values.need_code === 1
            })
        }
    },
    methods: {
        onOk () {
            const {
                form: { validateFields }
            } = this
            return new Promise(resolve => {
                // 回调resolve(true)关闭弹出层
                validateFields((errors, values) => {
                    if (!errors) {
                        this.formLoading = true
                        const url = this.$props.id ? apiList.update + this.$props.id : apiList.create
                        const methods = this.$props.id ? 'put' : 'post'
                        values.need_code = values.need_code ? 1 : 2
                        requestData(url, methods, values)
                            .then(res => {
                                this.$notification.success({
                                    message: res.msg
                                })
                                resolve(true) // 关闭弹出层
                            })
                            .finally(() => {
                                this.formLoading = false
                            })
                    }
                })
            })
        },
        onCancel () {
            return new Promise(resolve => {
                resolve(true)
            })
        }
    }
}
</script>
